import { useSnapshot } from 'valtio'
import { AppOptions, options } from './optionsStorage'
import { OptionMeta } from './react/OptionsItems'
import { BanIcon, CompactListIcon, FullListIcon } from './react/settings/icons'
import { SegmentedField } from './react/settings/SettingsUi'

const CHAT_SIZE_OPTIONS = [
  { value: 'off', label: 'Выкл.', icon: <BanIcon /> },
  { value: 'small', label: 'Малый', icon: <CompactListIcon /> },
  { value: 'wide', label: 'Широкий', icon: <FullListIcon /> },
] as const

/* Figma spec (section FONT CHAT): the presets differ in height only — both
   `chat-server-small` and `chat-server-big` are drawn at the same width. Small
   takes 35% of the height available to the chat column, wide takes all of it. */
const CHAT_SIZE_PRESETS = {
  small: { heightFraction: 0.35 },
  wide: { heightFraction: 1 },
}

const applyChatSize = (size: string) => {
  options.chatSize = size
  const hidden = options.disabledUiParts.includes('chat')
  if (size === 'off') {
    if (!hidden) options.disabledUiParts = [...options.disabledUiParts, 'chat']
    return
  }
  if (hidden) options.disabledUiParts = options.disabledUiParts.filter(part => part !== 'chat')
  const preset = CHAT_SIZE_PRESETS[size as keyof typeof CHAT_SIZE_PRESETS]
  if (!preset) return
  options.chatHeightFraction = preset.heightFraction
}

/** Lives on the root settings screen — the chat preset is the most reached-for setting. */
export const ChatSizeField = () => {
  const { chatSize } = useSnapshot(options)
  return <SegmentedField
    title='Размер чата'
    options={CHAT_SIZE_OPTIONS}
    value={chatSize}
    onChange={applyChatSize}
  />
}

/**
 * Group registry of the settings modal. Every reachable screen is a dedicated
 * component now (see `src/react/settings/`), so the groups carry no items.
 */
export const guiOptionsScheme: {
  [t in OptionsGroupType]: Array<{ [K in keyof AppOptions]?: Partial<OptionMeta<AppOptions[K]>> } & { custom? }>
} = {
  main: [],
  render: [],
  hud: [],
  chat: [],
  replay: [],
  interface: [],
  sound: [],
  advanced: [],
}
export type OptionsGroupType = 'main' | 'chat' | 'replay' | 'hud' | 'interface' | 'render' | 'sound' | 'advanced'
